import { get, post } from "@insite/client-framework/Services/ApiService";

const CustomerPricingExportDataUrl = "/api/v2/CustomerPricing/Export";

export function getCustomerPricingExportList(GetCustomerPricingExportDataUrl:string) {
    return get(`${GetCustomerPricingExportDataUrl}`);
}

export function uploadCustomerPricingData(parameter?: any) {
   return post(`${CustomerPricingExportDataUrl}`, parameter);
}
